import { createHead } from '@unhead/vue/client';
import type { UserModule } from '~/types';

// UnHead/vue https://unhead.unjs.io/
export const install: UserModule = ({ app }) => {
    const head = createHead();
    app.use(head);
};
